import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=133a13e0"
import script from "./TradingView.vue?vue&type=script&lang=ts"
export * from "./TradingView.vue?vue&type=script&lang=ts"
import style0 from "./TradingView.vue?vue&type=style&index=0&id=133a13e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports